import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { COMMENT_REPOSITORY, CommentRepository } from '@app/domain/repositories/comment.repository.contract';
import { Comment, CommentsPaginated } from '@app/entities/models/comment.model';

import { CommentUseCases } from './comment.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class CommentUseCasesImpl implements CommentUseCases {
  #commentRepository: CommentRepository = inject(COMMENT_REPOSITORY);

  getComments(content_id: string, pageRequest: number, last_viewed_id?: number): Observable<CommentsPaginated> {
    return this.#commentRepository.getComments(content_id, pageRequest, last_viewed_id);
  }

  getCommentsHighlighted(content_id: string): Observable<Comment[]> {
    return this.#commentRepository.getCommentsHighlighted(content_id);
  }

  getCommentById(comment_id: number): Observable<Comment> {
    return this.#commentRepository.getCommentById(comment_id);
  }

  createComment(
    content_id: number,
    comment: string,
    translation_key: string,
    parent_comment_id?: number,
    representedUser?: string
  ): Observable<Comment> {
    return this.#commentRepository.createComment(
      content_id,
      comment,
      translation_key,
      parent_comment_id,
      representedUser
    );
  }

  deleteComment(comment_id: number): Observable<object> {
    return this.#commentRepository.deleteComment(comment_id);
  }

  updateComment(comment_id: number, comment: string): Observable<Comment> {
    return this.#commentRepository.updateComment(comment_id, comment);
  }
}
